import script from "./EducationAutocomplete.vue?vue&type=script&setup=true&lang=js"
export * from "./EducationAutocomplete.vue?vue&type=script&setup=true&lang=js"

import "./EducationAutocomplete.vue?vue&type=style&index=0&id=0281a24d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0281a24d"]])

export default __exports__